/**
 * What a route test's test drops send today (user, 19/10/2026: "use the best
 * texts for the test drops"), read from the live text ranking the same way
 * the fill does: the pool is the ranked texts in the reuse pool, best first;
 * every test drop takes its first N, and a short pool is topped up with fresh
 * AI texts — one set for all test drops either way.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenTextMix, DropGenTextRankingPreview } from '@trafficpulse/shared';

export interface PoolText {
  text: string;
  score: number | null;
}

/** The ranking's reuse pool, best first (the fill's `poolTexts`). */
export const poolOf = (preview: DropGenTextRankingPreview): PoolText[] =>
  preview.texts.filter((t) => t.inPool && t.text).map((t) => ({ text: t.text as string, score: t.score }));

const texts = (n: number, word = 'text') => `${n} ${word}${n === 1 ? '' : 's'}`;

/** The line under the choice; `pool` null = the ranking is not read (yet, or at all). */
export function todayTextsLine(mix: DropGenTextMix, pool: PoolText[] | null, failed: boolean): string {
  const same = 'the same on every test drop';
  if (mix.proven === 0) return `${texts(mix.ai, 'fresh AI text')}, written once and sent on every test drop.`;
  if (failed) return `The text ranking can't be read, so the test drops send ${texts(mix.proven + mix.ai, 'fresh AI text')}, ${same}.`;
  if (pool === null) return 'Reading the text ranking…';
  if (pool.length === 0) return `No proven text in the ranking yet, so the test drops send ${texts(mix.proven + mix.ai, 'fresh AI text')}, ${same}.`;
  const used = Math.min(mix.proven, pool.length);
  const fill = mix.proven - used + mix.ai;
  if (fill === 0) return `Today: the ${used === 1 ? 'best text' : `${used} best texts`} below, ${same}.`;
  const short = used < mix.proven ? `The ranking has ${texts(used, 'proven text')} yet, so ` : '';
  return `${short}${texts(used, 'ranked text')} + ${texts(fill, 'fresh AI text')}, ${same}.`;
}
